export default {
  sm: `
    데이터센터에서 운행되는 무인 자율주행 셔틀입니다. 왕복 이동 동선 1km 이상, 축구장 41개 크기의 광활한 각 세종 부지 안을 근무자들이 편안하고 안전하게 이동할 수 있도록 돕습니다. 네이버의 독자적인 풀스택 자율주행 기술이 적용되어 있으며, 네이버 클라우드 플랫폼 기반의 '아크' 시스템으로 관제합니다.
  `,
  xl: `
    데이터센터에서 운행되는 무인 자율주행 셔틀입니다. 왕복 이동 동선 1km 이상, 축구장 41개 크기의 광활한 각 세종 부지 안을 근무자들이 
    편안하고 안전하게 이동할 수 있도록 돕습니다. 네이버의 독자적인 
    풀스택 자율주행 기술이 적용되어 있으며, 네이버 클라우드 플랫폼 
    기반의 '아크' 시스템으로 관제합니다.
  `,
};
